module.exports = __webpack_public_path__ + "static/media/imagenBeige.22f14af7.png";